import { CiCreditCard1 } from "react-icons/ci";
import { RiPaypalLine } from "react-icons/ri";

export const getPaymentIcon = (paymentMethod) => {
    switch (paymentMethod) {		
        case 'Card':				
            return <CiCreditCard1 />;		
        case 'PayPal':				
            return <RiPaypalLine />;		
        default:
            return;    	
    }
}

export const showAmount = (amount) => {
    if(amount === undefined  || amount === null){
        return false;
    }
    return true;
}